resourcePaths = '{"rootPath":"","assetsPath":""}';function InputCalendar() {
  this.extends = [InputText];
  this.node = null;
  this.id = null;

  // Properties
  this.placeholder = "";
  this.error = "";
  this.wizard = true;
  this.defaultDate = null; // Default view of calendar. String or date object. String format should be YYYY-MM-DD.
  this.hint = false; // Hint is shown according to defaultDate. Set to true to turn on hinting.
  this.seperator = "/";
  this.value = null; // Selected date. String or date object. String format should be YYYY-MM-DD.
  this.initialDecade = null; // Deprecated, use default date instead.
  this.timezone = null; // Defaults to client timezone. String format should be a timezone offset string. Eg. +05:30
  this.displayFormat = 'YYYY-MM-DD'; // The date format to display on the input field.

  // States used for generating view tables
  // Current variable defines current focus while selected variable define actual selection
  // Wizard variables used for wizard interface. Ignored once a full date is selected (year/month/day)
  this._currentDate = undefined;
  this._selectedDate = undefined;
  this._wizardYear = undefined;
  this._wizardMonth = undefined;
  this._dateTitles = {}; // Store date & message pairs to set the title attribute for date cells (e.g. {"2018/06/06": "This is a holiday!"})

  this._a11yPrevious = "Previous";
  this._a11yNext = "Next";
  this._inputDate = null; // Store date in full format. The displayed date will always be formatted from this value.

  this.mask = {
    format: undefined,
    add: function(value) { return this._addMaskCallback(value); }.bind(this),
    remove: function(value) { return this._removeMaskCallback(value); }.bind(this)
  };

  // Date Validation Callbacks
  this.yearValidation = undefined; // Arguments [year]
  this.monthValidation = undefined; // Arguments [year, month]
  this.dateValidation = undefined; // Arguments [year, month, day]
  // Alternative to above functions; if above functions defined, these are Ignored
  // possible values: 'today', 'tomorrow', 'yesterday', 'add \d {days|weeks|months|years}', 'subtract \d {days|weeks|months|years}', a date in this.displayFormat
  this.firstValidDate = undefined;
  this.lastValidDate = undefined;

  // Date Strings / Abbreviations
  this._months = [
    ['January', 'Jan'],
    ['February', 'Feb'],
    ['March', 'Mar'],
    ['April', 'Apr'],
    ['May', 'May'],
    ['June', 'Jun'],
    ['July', 'Jul'],
    ['August', 'Aug'],
    ['September', 'Sept'],
    ['October', 'Oct'],
    ['November', 'Nov'],
    ['December', 'Dec']
  ];

  this._daysOfWeek = [
    ['S', 'Sunday'],
    ['M', 'Monday'],
    ['T', 'Tuesday'],
    ['W', 'Wednesday'],
    ['T', 'Thursday'],
    ['F', 'Friday'],
    ['S', 'Saturday']
  ];

  this.init = function() {
    // setup load state to false until moment.js is loaded
    this._initialized = false;

    // set date format
    this.dateFormat = 'YYYY' + this.seperator + 'MM' + this.seperator + 'DD';

    // user typed input string will be calculated to a reasonable date based on this format
    this.calculationFormat = 'MMMM D, YYYY';

    // Classes
    this._classes = $.extend(this._classes, {
      calendar: 'input-calendar',
      mod_wizard: 'input-calendar--wizard',
      mod_open: 'input-calendar--open',
      mod_below: 'input-calendar--below',

      calendar_elm: 'input-calendar__calendar',
      calendar_svg: 'input-calendar__svg',
      input_svg: 'input-text__svg-icon',
      background: 'input-calendar__background',
      header: 'input-calendar__header',
      title: 'input-calendar__title',
      mod_title_nohover: 'input-calendar__title--no-hover',
      previous: 'input-calendar__previous',
      next: 'input-calendar__next',
      header_svg: 'input-calendar__header-svg',
      calendar_table: 'input-calendar__calendar-table',
      a11y_text: 'input-calendar__a11y-text',

      view: {
        class: 'input-calendar__view',
        header: 'input-calendar__view-header',
        view_container: 'input-calendar__view-container',
        date: 'input-calendar__date-view',
        month: 'input-calendar__month-view',
        year: 'input-calendar__year-view',
        active: 'input-calendar__active-view'
      },

      date_item: {
        class: 'input-calendar__date-item',
        link: 'input-calendar__date-link',
        selected: 'input-calendar__date-item--selected',
        unavailable: 'input-calendar__date-item--unavailable',
        not_in_view: 'input-calendar__date-item--not-in-view',
        today: 'input-calendar__date-item--today',
        help: 'input-calendar__date-help',
        hint: 'input-calendar__date-item--hint'
      }
    });

    this._super();

    // load moment.js
    if (typeof moment === "undefined") {
      var filePath = window.mogo.registry.mogoUI.config.resourcePaths.assetsPath + '/mogo-ui-lib-min/js/vendor/moment.min.js';
        $.ajax({
       url: filePath,
       dataType: "script",
       cache: true
     }).done(function () {
       this._initialized = true;
       this.initCal();
     }.bind(this));
    } else {
      this._initialized = true;
      this.initCal();
    }
  };

  this.initCal = function() {
    // Container
    this.containerDiv.addClass(this._classes.calendar);
    if(this.wizard) this.containerDiv.addClass(this._classes.mod_wizard);

    // Calendar
    this._$calendar = $('<div></div>').addClass(this._classes.calendar_elm);
    this._$calendar.attr("tabindex", "0");
    this._$calendar.attr("role", "application");
    this._$background = $('<div></div>').addClass(this._classes.background);

    // Calendar SVG
    this._$calendarSvg = $('<svg viewBox="0 0 32 35" class="svg-icon '+ [this._classes.calendar_svg, this._classes.input_svg].join(' ') +'"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-calendar"></use></svg>');

    // Calendar Header Setup and attachment
    this._$header = $('<header role="heading"></header>').addClass(this._classes.header);
    this._$title = $('<a href="#!"></a>').addClass(this._classes.title);
    this._$previous = $('<a href="#!"></a>').addClass(this._classes.previous);
    this._$next = $('<a href="#!"></a>').addClass(this._classes.next);
    this._$header.append(this._$title).append(this._$previous).append(this._$next);
    this._$calendar.append(this._$header);

    // Previous/Next Svgs
    this._$previousSvg = $('<svg class="svg-icon '+ this._classes.header_svg +'" viewBox="0 0 32 32"><use xlink:href="#icon-arrow-down-square" /></svg>');
    this._$nextSvg = $('<svg class="svg-icon '+ this._classes.header_svg +'" viewBox="0 0 32 32"><use xlink:href="#icon-arrow-down-square" /></svg>');

    // Previous/Next A11y Copy
    this._$previousA11y = $('<span></span>').addClass([this._classes.a11y_text, 'a11y__hidden-content'].join(' ')).text(this._a11yPrevious);
    this._$nextA11y = $('<span></span>').addClass([this._classes.a11y_text, 'a11y__hidden-content'].join(' ')).text(this._a11yNext);

    // Attach SVG and a11y to Previous/Next Buttons
    this._$previous.append(this._$previousSvg).append(this._$previousA11y);
    this._$next.append(this._$nextSvg).append(this._$nextA11y);

    // Setup Calendar Input Views
    this._$viewContainer = $('<div></div>').addClass(this._classes.view.view_container);
    this._$viewContainer.attr("role", "grid");
    this._$viewYear = $('<table></table>').addClass([this._classes.view.class, this._classes.view.year].join(' '));
    this._$viewMonth = $('<table></table>').addClass([this._classes.view.class, this._classes.view.month].join(' '));
    this._$viewDate = $('<table></table>').addClass([this._classes.view.class, this._classes.view.date].join(' '));

    // Attach Calendar Input Views and Calendar to container
    this._$viewContainer.append(this._$viewYear).append(this._$viewMonth).append(this._$viewDate);
    this._$calendar.append(this._$viewContainer);

    this.containerDiv.append(this._$calendarSvg);
    this.containerDiv.append(this._$calendar);
    this.containerDiv.append(this._$background);

    // Run Calendar Setup functions
    this._setupEvents();

    if (this._pending !== null) {
      this[this._pending[0]](this._pending[1]);
      this._pending = null;
    }

    // Setup default state data
    this._setupDefaultState();
    this.onDataBindUpdate('defaultDate', this._setupDefaultState.bind(this));
    this.onDataBindUpdate('value', this._setupDefaultState.bind(this));
    this.onDataBindUpdate('timezone', function() {
      this._today = null;
      this._getToday();
    }.bind(this));

    // create validation methods if firstValidDate or lastValidDate set
    if (!(this.yearValidation || this.monthValidation || this.dateValidation) && this.firstValidDate || this.lastValidDate) {
      if (this.firstValidDate) {
        var firstDateObj = this._parseBookendDate(this.firstValidDate);
      }
      if (this.lastValidDate) {
        var lastDateObj = this._parseBookendDate(this.lastValidDate);
      }

      this.yearValidation = function (year) {
        var validDate = true;
        if (firstDateObj && firstDateObj.year() > year) {
          validDate = false;
        }
        if (lastDateObj && lastDateObj.year() < year) {
          validDate = false;
        }
        return validDate;
      };

      this.monthValidation = function (year, month) {
        var validDate = this.yearValidation(year);
        if (firstDateObj && firstDateObj.year() == year && firstDateObj.month() > month) {
          validDate = false;
        }
        if (lastDateObj && lastDateObj.year() == year && lastDateObj.month() < month) {
          validDate = false;
        }
        return validDate;
      };

      this.dateValidation = function (year, month, day) {
        var validDate = this.monthValidation(year, month);
        if (firstDateObj && firstDateObj.year() == year && firstDateObj.month() == month && firstDateObj.date() > day) {
          validDate = false;
        }
        if (lastDateObj && lastDateObj.year() == year && lastDateObj.month() == month && lastDateObj.date() < day) {
          validDate = false;
        }
        return validDate;
      }
    }
  };

  this._setupDefaultState = function() {
    if (typeof this.defaultDate == "string") {
      var dateSplit = this.defaultDate.split("-");
      this.defaultDate = new Date(parseInt(dateSplit[0]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[2]));
    } else if (this.initialDecade && !isNaN(parseInt(this.initialDecade))) {
      console.warn("initialDecade is deprecated, use defaultDate instead");
      this.defaultDate = new Date(parseInt(this.initialDecade), 0, 1);
    }

    if (this.value && typeof this.value == "string") {
      var dateSplit = this.value.split("-");
      this.value = new Date(parseInt(dateSplit[0]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[2]));
      this._currentDate = this.value;
    }

    // Last check
    if (this.defaultDate && isNaN(this.defaultDate.getDate())) this.defaultDate = new Date();

    // Set value
    if (moment(this.value)._d != "Invalid Date") {
      this._selectedDate = this.value;
      this.val(moment(this.value).format(this.dateFormat));
    } else {
      this._selectedDate = null;
    }

    // Assign current date
    this._currentDate = this._selectedDate || this.defaultDate || this._getToday();
  };

  this.initAllReady = function() { this._super(); };

  this.destroy = function() { this._super(); };

  this.setYearValidation = function(callback) {
    this.yearValidation = callback; // Arguments [year]
  };

  this.setMonthValidation = function(callback) {
    this.monthValidation = callback; // Arguments [year, month]
  };

  this.setDateValidation = function(callback) {
    this.dateValidation = callback; // Arguments [year, month, day]
  };

  this.updateToday = function (newDate) {
    if (moment(newDate)._d != 'Invalid Date') {
      this._today = new Date(moment(newDate).format(this.dateFormat));
    }
  };

  this.updateCurrentDate = function (newDate) {
    if (moment(newDate)._d != 'Invalid Date') {
      this._currentDate = moment(newDate).toDate();
    }
  };

  this.val = function (value) {
    if (value === undefined) {
      return this._super();
    } else {
      this._super(value);
      this._syncCalendar(value);
    }
  };

  this.getState = function () {
    var states = ['selected', 'invalid', 'unselected'];
    if (!this.val()) {
      return states[2];
    } else if (moment(this._inputDate).format(this.dateFormat) == moment(this._selectedDate).format(this.dateFormat)) {
      return states[0];
    } else {
      return states[1];
    }
  };

  /*
    Take in an array of objects, and convert it to a map of date & message pairs.
    Arguments:
      titles [object] (required):
        each object in the array stores a pair of a date and a title message as
        a tooltip to that date (e.g. {"2018/06/06": "This is a holiday!"}).
        The provided date is not required a specific format as long as it's valid,
        since it will be unified in this function by using this.dateFormat.
  */
  this.setDateTitles = function (titles) {
    if (titles && titles.length > 0) {
      this._dateTitles = titles.reduce(function (result, item) {
        var key = Object.keys(item)[0];
        result[moment(key).format(this.dateFormat)] = item[key];
        return result;
      }.bind(this), {});
    }
  };

  this._addMaskCallback = function(value) {
    this._inputDate = value;
    if (value == null || new Date(value) == "Invalid Date" || value.indexOf(',') > -1) return value;
    if(value.indexOf('T') > -1) value = value.split('T')[0];

    return moment(value).format(this.displayFormat);
  };

  this._removeMaskCallback = function(value) {
    var date = moment(value, this.calculationFormat);
    if (date._d == "Invalid Date") return value;

    return date.format(this.dateFormat);
  };

  this._setupEvents = function() {
    this.containerDiv.on('click.InputCalendar', this._showCalendar.bind(this));
    this._$previous.on('click', this._onClickNavigation.bind(this, 'previous'));
    this._$next.on('click', this._onClickNavigation.bind(this, 'next'));
    this._$title.on('click', this._onClickNavigation.bind(this, 'title'));
    this.$node.on(this._events.update, this._syncCalendar.bind(this));
    this.$node.on(this._events.focus, this._showCalendar.bind(this));
    this.$node.on('keydown.InputCalendar', this._onKeyDownCalendar.bind(this));
    this._$calendar.on('keydown.InputCalendar', this._onKeyDownCalendar.bind(this));
  };

  this._delayedBlur = function() {
    setTimeout(function() {
      if (!$.contains(this.containerDiv[0], document.activeElement)) {
        this._hideCalendar();
      }
    }.bind(this), 100);
  };

  this._onKeyDownCalendar = function(e) {
    var activeView = this._$calendar.find("." + this._classes.view.active);
    if (e.which == 27) {
      e.preventDefault();
      // ESC key
      if (this.containerDiv.hasClass(this._classes.mod_open)) {
        this.$node.focus();
        this._hideCalendar();
      } else {
        this._showCalendar();
      }
    } else if (e.which == 37 || e.which == 38) {
      e.preventDefault();
      // Left/up
      if ($(e.target).parents("." + this._classes.header).length > 0) {
        // From header
        if (activeView.hasClass(this._classes.view.year)) {
          this._clickYearPrevious(e);
        } else if (activeView.hasClass(this._classes.view.month)) {
          this._clickMonthPrevious(e);
        } else if (activeView.hasClass(this._classes.view.date)) {
          this._clickDatePrevious(e);
        }
      } else if ($(e.target).parents("." + this._classes.view.view_container).length > 0) {
        // From calendar grid
        if (e.which == 37) {
          if (activeView.hasClass(this._classes.view.year)) {
            this._moveFocus(-1, "year");
          } else if (activeView.hasClass(this._classes.view.month)) {
            this._moveFocus(-1, "month");
          } else if (activeView.hasClass(this._classes.view.date)) {
            this._moveFocus(-1, "day");
          }
        } else {
          if (activeView.hasClass(this._classes.view.year)) {
            this._moveFocus(-4, "year");
          } else if (activeView.hasClass(this._classes.view.month)) {
            this._moveFocus(-4, "month");
          } else if (activeView.hasClass(this._classes.view.date)) {
            this._moveFocus(-7, "day");
          }
        }
      }
    } else if (e.which == 39 || e.which == 40) {
      e.preventDefault();
      // Right/down
      if ($(e.target).parents("." + this._classes.header).length > 0) {
        // From header
        if (activeView.hasClass(this._classes.view.year)) {
          this._clickYearNext(e);
        } else if (activeView.hasClass(this._classes.view.month)) {
          this._clickMonthNext(e);
        } else if (activeView.hasClass(this._classes.view.date)) {
          this._clickDateNext(e);
        }
      } else if ($(e.target).parents("." + this._classes.view.view_container).length > 0) {
        // From calendar grid
        if (e.which == 39) {
          if (activeView.hasClass(this._classes.view.year)) {
            this._moveFocus(1, "year");
          } else if (activeView.hasClass(this._classes.view.month)) {
            this._moveFocus(1, "month");
          } else if (activeView.hasClass(this._classes.view.date)) {
            this._moveFocus(1, "day");
          }
        } else {
          if (activeView.hasClass(this._classes.view.year)) {
            this._moveFocus(4, "year");
          } else if (activeView.hasClass(this._classes.view.month)) {
            this._moveFocus(4, "month");
          } else if (activeView.hasClass(this._classes.view.date)) {
            this._moveFocus(7, "day");
          }
        }
      }
    } else if (e.which != 13) {
      // Not Enter
      this._delayedBlur();
    }
  };

  this._showCalendar = function(e) {
    if (this.containerDiv.hasClass(this._classes.mod_open)) return;
    if (e) e.stopPropagation();

    // Listener to close
    $(document).on('click.InputCalendar', this._hideCalendar.bind(this));

    // Set state
    if (!this.containerDiv.hasClass(this._classes.mod_open)) {
      if (this.wizard && !this._selectedDate) this._setView('year');
      else this._setView('date');
    }

    this._setPosition();
    this.containerDiv.addClass(this._classes.mod_open);

    if (this._$background.filter(":visible").length > 0) {
      this._$calendar.focus();
    }
  };

  this._hideCalendar = function (e) {
    
    if (arguments.length > 0) {
      e.preventDefault();
      e.stopPropagation();

      // Continue to remove calendar when click container is anything but the background filter
      if (!$(e.target).hasClass(this._classes.background)) {
        
        // Do nothing when:
        // - there's no open class, guard
        // - when there's background filter
        // - when the input textfield is clicked
        if (
          !this.containerDiv.hasClass(this._classes.mod_open) ||
          ((this._$background.filter(':visible').length > 0)) ||
          $.contains(this.containerDiv[0], e.target)
        ) {
          return;
        }
      }
    }

    this.containerDiv.removeClass(this._classes.mod_open);
    $(document).off('click.InputCalendar');
  };

  this._syncCalendar = function (newDate) {
    var val = typeof newDate == 'string' ? this._inputDate : this.val();
    var compareFormat = 'MM DD';
    if (this._selectedDate && moment(this._selectedDate).format(compareFormat) == moment(val).format(compareFormat)) {
      return;
    }

    this._selectedDate = null;
    if (val && moment(val)._d != "Invalid Date") {
      this._currentDate = moment(val).toDate();
      if (this._checkValidation(this._currentDate.getFullYear(), this._currentDate.getMonth(), this._currentDate.getDate())) {
        this._selectedDate = this._currentDate;
      }
    }
    this._updateCurrentView();
  };

  this._updateCurrentView = function() {
    var activeView = this._$calendar.find("." + this._classes.view.active);
    if (activeView.hasClass(this._classes.view.year)) {
      this._setView("year");
    } else if (activeView.hasClass(this._classes.view.month)) {
      this._setView("month");
    } else if (activeView.hasClass(this._classes.view.date)) {
      this._setView("date");
    }
  };

  this._setView = function(view) {
    this.containerDiv.find('.'+ this._classes.view.active).removeClass(this._classes.view.active);

    if (view === 'year') {
      var currentDecade = parseInt(this._currentDate.getFullYear() / 10) * 10;
      this._generateYearView();
      this._$viewYear.addClass(this._classes.view.active);
      this._$title.text(currentDecade + ' - '+ (currentDecade + 9)).addClass(this._classes.mod_title_nohover);
      this._$viewYear.find('.'+ this._classes.date_item.link).on('click.InputCalendar', this._clickYearDateItem.bind(this));

    } else if (view === 'month') {
      this._generateMonthView();
      this._$viewMonth.addClass(this._classes.view.active);
      this._$title.text(this._currentDate.getFullYear()).removeClass(this._classes.mod_title_nohover);
      this._$viewMonth.find('.'+ this._classes.date_item.link).on('click.InputCalendar', this._clickMonthDateItem.bind(this));

    } else if (view === 'date') {
      this._generateDateView();
      this._$viewDate.addClass(this._classes.view.active);
      this._$title.text([
        this._months[this._currentDate.getMonth()][0],
        this._currentDate.getFullYear()
      ].join(' ')).removeClass(this._classes.mod_title_nohover);

      this._$viewDate.find('.'+ this._classes.date_item.link).on('click.InputCalendar', this._clickDateDateItem.bind(this));
    }
  };

  // Previous/next
  this._onClickNavigation = function(type, e) {
    var activeView = this._$calendar.find("." + this._classes.view.active);
    if (activeView.hasClass(this._classes.view.year)) {
      if (type === "next") this._clickYearNext(e);
      else if (type === "previous") this._clickYearPrevious(e);
    } else if (activeView.hasClass(this._classes.view.month)) {
      if (type === "next") this._clickMonthNext(e);
      else if (type === "previous") this._clickMonthPrevious(e);
      else if (type === "title") this._clickMonthTitle(e);
    } else if (activeView.hasClass(this._classes.view.date)) {
      if (type === "next") this._clickDateNext(e);
      else if (type === "previous") this._clickDatePrevious(e);
      else if (type === "title") this._clickDateTitle(e);
    }
  };

  // Year Events
  this._clickYearPrevious = function(e) {
    e.preventDefault();
    this._currentDate = moment(this._currentDate).subtract(10, "year").toDate();
    this._setView('year');
  };

  this._clickYearNext = function(e) {
    e.preventDefault();
    this._currentDate = moment(this._currentDate).add(10, "year").toDate();
    this._setView('year');
  };

  this._clickYearDateItem = function(e) {
    e.preventDefault();
    var $this = $(e.currentTarget);
    if ($this.parent().hasClass(this._classes.date_item.unavailable)) return false;

    if (!this._selectedDate) {
      this._wizardYear = $this.attr('data-value') * 1;
    } else {
      this._selectedDate.setFullYear($this.attr('data-value') * 1);
    }
    this._currentDate.setFullYear($this.attr('data-value') * 1);
    this._setView('month');
  };

  // Month Events
  this._clickMonthTitle = function(e) {
    e.preventDefault();
    this._setView('year');
  };

  this._clickMonthPrevious = function(e) {
    e.preventDefault();
    this._currentDate = moment(this._currentDate).subtract(1, "year").toDate();
    this._setView('month');
  };

  this._clickMonthNext = function(e) {
    e.preventDefault();
    this._currentDate = moment(this._currentDate).add(1, "year").toDate();
    this._setView('month');
  };

  this._clickMonthDateItem = function(e) {
    e.preventDefault();
    var $this = $(e.currentTarget);
    if ($this.parent().hasClass(this._classes.date_item.unavailable)) return false;

    if (!this._selectedDate) {
      this._wizardMonth = $this.attr('data-value') * 1;
      this._wizardYear = this._currentDate.getFullYear();
    } else {
      var newDate = new Date(this._selectedDate.getTime());
      newDate.setMonth($this.attr('data-value') * 1);
      if (this._checkValidation(newDate.getFullYear(), newDate.getMonth(), newDate.getDate())) {
        // Valid date
        this._selectedDate.setMonth($this.attr('data-value') * 1);
        this.val(moment(this._selectedDate).format(this.dateFormat));
      }
    }
    this._currentDate.setMonth($this.attr('data-value') * 1);
    this._setView('date');
  };

  // Date Events
  this._clickDateTitle = function(e) {
    e.preventDefault();
    this._setView('month');
  };

  this._clickDatePrevious = function(e) {
    e.preventDefault();
    this._currentDate = moment(this._currentDate).subtract(1, "month").toDate();
    this._setView('date');
  };

  this._clickDateNext = function(e) {
    e.preventDefault();
    this._currentDate = moment(this._currentDate).add(1, "month").toDate();
    this._setView('date');
  };

  this._clickDateDateItem = function(e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(e.currentTarget);
    if ($this.parent().hasClass(this._classes.date_item.unavailable)) return false;

    this._selectedDate = new Date(this._currentDate.getFullYear(), this._currentDate.getMonth(), $this.attr('data-value') * 1);
    this.node.value = (moment(this._selectedDate, this.calculationFormat).format(this.calculationFormat));
    this._inputDate = this.node.value;
    this.$node.trigger('change');
    this._hideCalendar();
  };

  this._generateYearView = function() {
    var $body = $('<tbody></tbody>');
    var rows = $('<tr></tr><tr></tr><tr></tr>');
    var $yearElement = $('<td><a  href="#!"></a></td>').addClass(this._classes.date_item.class);
    var decade = Math.floor(this._currentDate.getFullYear() / 10) * 10;

    for (var i = -1; i < 11; i++) {
      var year = decade + i;
      var row = Math.floor(((i+2) - 0.1) / 4);

      var $yearClone = $yearElement.clone();
      var $a = $yearClone.find('a');
      $a.text(year).attr('data-value', year).addClass(this._classes.date_item.link);
      $a.attr("tabindex", "-1");

      // check if valid
      if (i === -1 || i === 10 || !this._checkValidation(year)) {
        $yearClone.addClass(this._classes.date_item.unavailable);
        if (i === -1 || i === 10) {
          $yearClone.addClass(this._classes.date_item.not_in_view);
        }
      } else {
        // selected (in valid range)
        if ((this._selectedDate && this._selectedDate.getFullYear() === year) ||
            (!this._selectedDate && this._wizardYear && this._wizardYear === year)) {
          $yearClone.addClass(this._classes.date_item.selected);
        }
      }

      // "current" date
      if (this._currentDate) {
        var currentDate = moment(this._currentDate);
        if (currentDate._d != "Invalid Date" && currentDate.year() === year) {
          $a.attr("tabindex", "0");
        }
      }

      // today
      if (year === this._getToday().getFullYear()) {
        $yearClone.addClass(this._classes.date_item.today);
        $yearClone.attr("aria-label", "current year");
      }

      // hint
      if (this.defaultDate && this.hint) {
        var defaultDate = moment(this.defaultDate);
        if (defaultDate._d != "Invalid Date" && defaultDate.year() === year) {
          $yearClone.addClass(this._classes.date_item.hint);
        }
      }

      rows.eq(row).append($yearClone);
    }

    this._$viewYear.empty().append($body);
    $body.append(rows.eq(0), rows.eq(1), rows.eq(2));
  };

  this._generateMonthView = function() {
    var $body = $('<tbody></tbody>');
    var rows = $('<tr></tr><tr></tr><tr></tr>');
    var $monthElement = $('<td><a  href="#!"></a></td>').addClass(this._classes.date_item.class);

    for (var i = 0; i < 12; i++) {
      var row = Math.floor(((i + 1) - 0.1) / 4);
      var month = this._months[i][1];

      var $monthClone = $monthElement.clone();
      var $a = $monthClone.find('a');
      $a.text(month).attr('data-value', i).addClass(this._classes.date_item.link);
      $a.attr("tabindex", "-1");

      // check if valid
      if (typeof this._currentDate.getFullYear() !== "undefined" && !this._checkValidation(this._currentDate.getFullYear(), i)) {
        $monthClone.addClass(this._classes.date_item.unavailable);
      }

      // Selected
      if ((this._selectedDate && this._currentDate.getFullYear() === this._selectedDate.getFullYear() && i === this._selectedDate.getMonth()) ||
          (!this._selectedDate && this._wizardMonth && this._currentDate.getFullYear() === this._wizardYear && i === this._wizardMonth)) {
        $monthClone.addClass(this._classes.date_item.selected);
      }

      // "current" date
      if (this._currentDate) {
        var currentDate = moment(this._currentDate);
        if (currentDate._d != "Invalid Date" && currentDate.month() === i) {
          $a.attr("tabindex", "0");
        }
      }

      // today
      if (i === this._getToday().getMonth() && this._currentDate.getFullYear() === this._getToday().getFullYear()) {
        $monthClone.addClass(this._classes.date_item.today);
        $monthClone.attr("aria-label", "current month");
      }

      // hint
      if (this.defaultDate && this.hint) {
        if (this.defaultDate._d != "Invalid Date" && this._currentDate.getFullYear() === this.defaultDate.getFullYear() &&
            i === this.defaultDate.getMonth()) {
          $monthClone.addClass(this._classes.date_item.hint);
        }
      }

      rows.eq(row).append($monthClone);
    }

    this._$viewMonth.empty().append($body);
    $body.append(rows.eq(0), rows.eq(1), rows.eq(2));
  };

  this._generateDateView = function() {
    var $header = $('<thead></thead>').addClass(this._classes.view.header);
    var $tr = $('<tr></tr>>');
    $header.append($tr);
    for (var i = 0; i < this._daysOfWeek.length; i++) {
      var $th = $('<th></th>');
      var $abbr = $('<abbr title="' + this._daysOfWeek[i][1] + '">' + this._daysOfWeek[i][0] + '</abbr>');
      $th.append($abbr);
      $tr.append($th);
    }
    var $body = $('<tbody></tbody>');
    var $dateElement = $('<td><a href="#!" tabindex="-1"></a></td>').addClass(this._classes.date_item.class);
    var year = this._currentDate.getFullYear();
    var month = this._currentDate.getMonth();

    var today = moment(this._getToday());
    var startOfMonth = moment([year, month, 1]);
    var endOfMonth = startOfMonth.clone().add(1, 'month').date(0);
    var firstSunday = startOfMonth.day() === 0 ? startOfMonth.clone() : startOfMonth.clone().add(startOfMonth.day() * -1, 'day');
    var lastSaturday = endOfMonth.day() === 6 ? endOfMonth.clone() : endOfMonth.clone().add(6 - (endOfMonth.day()), 'day');
    var yearOffset = (lastSaturday.year() - firstSunday.year()) * 365;
    var displayLength = lastSaturday.dayOfYear() - firstSunday.dayOfYear() + yearOffset + 1;

    for (var i = 0; i < displayLength; i++) {
      var row = Math.floor(i / 7);
      var date = firstSunday.clone().add(i, 'day');
      var $dateClone = $dateElement.clone();
      var dateOfMonth = date.date();

      var $a = $dateClone.find('a');
      $a.attr('data-value', dateOfMonth).text(dateOfMonth).addClass(this._classes.date_item.link);
      var titleMsg = this._getTitleForDate(date);
      if (titleMsg) {
        $a.attr('title', titleMsg);
        $a.addClass(this._classes.date_item.help);
      }

      // invalid
      if (date.valueOf() < startOfMonth.valueOf() || date.valueOf() > endOfMonth.valueOf() || (date._d != "Invalid Date" && !this._checkValidation(date.year(), date.month(), date.date()))) {
        $dateClone.addClass(this._classes.date_item.unavailable);
        if (date.valueOf() < startOfMonth.valueOf() || date.valueOf() > endOfMonth.valueOf()) {
          $dateClone.addClass(this._classes.date_item.not_in_view);
          $dateClone.attr("aria-hidden", true);
        } else {
          $a.attr("aria-disabled", true);
        }
        $a.attr("tabindex", "-1");
      }

      // "current" date
      if (this._currentDate) {
        var currentDate = moment(this._currentDate);
        if (currentDate._d != "Invalid Date" && currentDate.year() === date.year() && currentDate.month() === date.month() && currentDate.date() === date.date()) {
          $a.attr("tabindex", "0");
        }
      }

      // today
      if (date.year() === today.year() && date.month() === today.month() && date.date() === today.date()) {
        $dateClone.addClass(this._classes.date_item.today);
        $dateClone.attr("aria-label", "today");
      }

      // selected
      if (this._selectedDate) {
        var selectedDate = moment(this._selectedDate);
        if (selectedDate._d != "Invalid Date" && selectedDate.year() === date.year() && selectedDate.month() === date.month() && selectedDate.date() === date.date()) {
          $dateClone.addClass(this._classes.date_item.selected);
          $dateClone.attr("aria-selected", true);
        }
      }

      // hint
      if (this.defaultDate && this.hint) {
        var defaultDate = moment(this.defaultDate);
        if (defaultDate._d != "Invalid Date" && defaultDate.year() === date.year() && defaultDate.month() === date.month() && defaultDate.date() === date.date()) {
          $dateClone.addClass(this._classes.date_item.hint);
        }
      }

      if ($body.find('tr').length < (row + 1)) $body.append('<tr></tr>');
      $body.find('tr').eq(row).append($dateClone);
    }

    this._$viewDate.empty().append($header, $body);
  };

  this._getTitleForDate = function (currentDate) {
    var formatedDate = currentDate.format(this.dateFormat);
    return this._dateTitles[formatedDate];
  };

  this._getToday = function() {
    if (!this._today) {
      this._today = new Date();
      if (this.timezone) this._today = Date.getOtherTimezoneTime(this._today, this.timezone);
    }
    return this._today;
  };

  this._setPosition = function() {
    var maxHeight = 355; // 345 + 10px padding
    var scrollPos = $(document).scrollTop();
    var offset = this.$node.offset().top;

    if (offset - scrollPos - maxHeight < 0) this.containerDiv.addClass(this._classes.mod_below);
    else this.containerDiv.removeClass(this._classes.mod_below);
  };

  this._moveFocus = function(magnitude, unit) {
    var newDate = moment(this._currentDate).add(magnitude, unit).toDate();
    var activeView = this._$calendar.find("." + this._classes.view.active);
    if (activeView.hasClass(this._classes.view.year)) {
      if (Math.floor(newDate.getFullYear() / 10) * 10 != Math.floor(this._currentDate.getFullYear() / 10) * 10) {
        if (Math.abs(magnitude) > 1) {
          var delta = (magnitude < 0) ? -2 : 2;
          newDate = moment(this._currentDate).toDate();
          while (Math.floor(newDate.getFullYear() / 10) * 10 === Math.floor(this._currentDate.getFullYear() / 10) * 10) {
            newDate = moment(newDate).add(delta, unit).toDate();
          }
        }
        this._currentDate = newDate;
        this._setView('year');
      } else {
        this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + this._currentDate.getFullYear() + '"]')
            .attr("tabindex", "-1");
        this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + newDate.getFullYear() + '"]')
            .attr("tabindex", "0");
        this._currentDate = newDate;
      }
      this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + newDate.getFullYear() + '"]').focus();
    } else if (activeView.hasClass(this._classes.view.month)) {
      if (newDate.getFullYear() != this._currentDate.getFullYear()) {
        this._currentDate = newDate;
        this._setView('month');
      } else {
        this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + this._currentDate.getMonth() + '"]')
            .attr("tabindex", "-1");
        this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + newDate.getMonth() + '"]')
            .attr("tabindex", "0");
        this._currentDate = newDate;
      }
      this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + newDate.getMonth() + '"]').focus();
    } else if (activeView.hasClass(this._classes.view.date)) {
      if (newDate.getMonth() != this._currentDate.getMonth()) {
        this._currentDate = newDate;
        this._setView('date');
      } else {
        this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + this._currentDate.getDate() + '"]')
            .attr("tabindex", "-1");
        this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + newDate.getDate() + '"]')
            .attr("tabindex", "0");
        this._currentDate = newDate;
      }
      this._$calendar.find('td:not(.input-calendar__date-item--not-in-view) [data-value="' + newDate.getDate() + '"]').focus();
    }
  };

  this._checkValidation = function(year, month, date) {
    if (arguments.length == 1) {
      if (typeof this.yearValidation === "function" && !this.yearValidation(year)) return false;
    } else if (arguments.length == 2) {
      if (typeof this.monthValidation === "function" && !this.monthValidation(year, month)) return false;
    } else if (arguments.length == 3) {
      if (typeof this.dateValidation === "function" && !this.dateValidation(year, month, date)) return false;
    }
    return true;
  };

  this._parseBookendDate = function (dateString) {
    var value = null;
    var stringWords = dateString.split(' ');
    if (stringWords[0].toLowerCase() === 'add' && !isNaN(stringWords[1])) {
      value = moment().add(stringWords[1], stringWords[2]);
    } else if (stringWords[0].toLowerCase() === 'subtract' && !isNaN(stringWords[1])) {
      value = moment().subtract(stringWords[1], stringWords[2]);
    } else if (dateString.toLowerCase() === 'today') {
      value = moment();
    } else if (dateString.toLowerCase() === 'tomorrow') {
      value = moment().add(1, 'days');
    } else if (dateString.toLowerCase() === 'yesterday') {
      value = moment().subtract(1, 'days');
    } else {
      value = moment(dateString, this.displayFormat);
    }
    if (!value.isValid()) {
      value = moment();
    }
    return value;
  };
}
